//import DashBoardLayerTwo from "../../components/dash/Dasboard";
import Dashboard from "../../components/dash/global/Dasboard";
import TutorialVideoPage from "../../components/test/Quiz/tutorial/TutorialVideoPage";
import MisTalentosPage from "../../pages/test/MisTalentosPage";
import QuizPage from "../../pages/test/Quiz/QuizPage";
import ConfirmacionTalentosPage from "../../pages/test/Quiz/ConfirmacionTalentosPage";
import FortalezasPage from "../../pages/test/Quiz/FortalezasPage";
import PreguntasTalentoQuizPage from "../../pages/test/Quiz/PreguntasTalentoQuizPage";
import TestPage from "../../pages/test/TestPage";
import { ROLES } from "../role.constants";
import QuizApplicationPage from "../../pages/test/QuizApplication/QuizApplicationPage";
import { Navigate } from "react-router-dom";
import ViewProfilePage from "../../pages/ViewProfilePage";
import AgendaPage from "../../pages/agenda/AgendaPage";
import ActividadesPage from "../../pages/classroom/ActividadesPage";
import ConversacionPage from "../../pages/conversacion/ConversacionPage";
import MisFortalezasPage from "../../pages/fortalezas/MisFortalezasPage";

export const sharedRoutes = [
  {
    path: "/dashboard",
    element: <Dashboard />,
    roles: [ROLES.ADMIN_SYS, ROLES.ADMIN_ESCOLAR],
  },
  {
    path: "/",
    element: <TestPage />,
    roles: [ROLES.ADMIN_SYS, ROLES.ADMIN_ESCOLAR, ROLES.ESTUDIANTE],
  },
  {
    path: "/test-quiz",
    element: <QuizPage />,
    roles: [ROLES.ADMIN_SYS, ROLES.ADMIN_ESCOLAR, ROLES.ESTUDIANTE],
  },
  {
    path: "/mis-talentos",
    element: <MisTalentosPage />,
    roles: [ROLES.ADMIN_SYS, ROLES.ADMIN_ESCOLAR, ROLES.ESTUDIANTE],
  },
  {
    path: "/confirmacion-talentos",
    element: <ConfirmacionTalentosPage />,
    roles: [ROLES.ADMIN_SYS, ROLES.ADMIN_ESCOLAR, ROLES.ESTUDIANTE],
  },
  // Quiz viejo de Fortalezas — oculto, redirige al nuevo (Fortalezas 2.0).
  // El componente FortalezasPage y su backend quedan sin tocar.
  {
    path: "/fortaleza-talentos",
    element: <Navigate to="/fortalezas-quiz" replace />,
    roles: [ROLES.ADMIN_SYS, ROLES.ADMIN_ESCOLAR, ROLES.ESTUDIANTE],
  },
  {
    path: "/fortalezas-quiz",
    element: <PreguntasTalentoQuizPage />,
    roles: [ROLES.ADMIN_SYS, ROLES.ADMIN_ESCOLAR, ROLES.ESTUDIANTE],
  },
  {
    path: "/tutorial-video",
    element: <TutorialVideoPage />,
    roles: [ROLES.ADMIN_SYS, ROLES.ADMIN_ESCOLAR, ROLES.ESTUDIANTE],
  },
  // Quiz viejo de Aplicación — oculto, redirige al nuevo (Fortalezas 2.0).
  // El componente QuizApplicationPage y su backend quedan sin tocar.
  {
    path: "/aplicacion-talento",
    element: <Navigate to="/fortalezas-quiz" replace />,
    roles: [ROLES.ADMIN_SYS, ROLES.ADMIN_ESCOLAR, ROLES.ESTUDIANTE],
  },
  {
    path: "/view-profile",
    element: <ViewProfilePage />,
    roles: [ROLES.ADMIN_SYS, ROLES.ADMIN_ESCOLAR, ROLES.ESTUDIANTE],
  },
  {
    path: "/agenda",
    element: <AgendaPage />,
    roles: [
      ROLES.ADMIN_SYS,
      ROLES.ADMIN_ESCOLAR,
      ROLES.MENTOR,
      ROLES.ESTUDIANTE,
    ],
  },
  {
    path: "/mis-actividades",
    element: <ActividadesPage />,
    roles: [
      ROLES.ADMIN_SYS,
      ROLES.ADMIN_ESCOLAR,
      ROLES.MENTOR,
      ROLES.ESTUDIANTE,
    ],
  },
  {
    path: "/conversacion",
    element: <ConversacionPage />,
    roles: [ROLES.ADMIN_SYS, ROLES.ADMIN_ESCOLAR, ROLES.MENTOR, ROLES.ESTUDIANTE],
  },
  {
    path: "/mis-fortalezas",
    element: <MisFortalezasPage />,
    roles: [ROLES.ADMIN_SYS, ROLES.ADMIN_ESCOLAR, ROLES.MENTOR, ROLES.ESTUDIANTE],
  },
];
